module.exports = __webpack_public_path__ + "assets/remove-value.9217007b.svg";